"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/card-atm.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fcard-atm.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardPinStatusToJSON = exports.cardPinStatusFromJSON = exports.CardAtm = exports.CardPinStatus = void 0;
const protobufPackage = 'com.step.common.proto.atm';
/**
 * Card PIN status
 */
var CardPinStatus;
(function (CardPinStatus) {
    CardPinStatus["INVALID_CARD_PIN_STATUS"] = "INVALID_CARD_PIN_STATUS";
    CardPinStatus["ACTIVE"] = "ACTIVE";
    CardPinStatus["BLOCKED"] = "BLOCKED";
    /**
     * PENDING - Pending status is set by the client, after successful Stripe SDK call.
     */
    CardPinStatus["PENDING"] = "PENDING";
    CardPinStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardPinStatus || (exports.CardPinStatus = CardPinStatus = {}));
function createBaseCardAtm() {
    return { enabled: false };
}
exports.CardAtm = {
    fromJSON(object) {
        const message = {
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        return obj;
    },
    create(base) {
        return exports.CardAtm.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardAtm();
        message.enabled = object.enabled ?? false;
        return message;
    },
};
function cardPinStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CARD_PIN_STATUS':
            return CardPinStatus.INVALID_CARD_PIN_STATUS;
        case 1:
        case 'ACTIVE':
            return CardPinStatus.ACTIVE;
        case 2:
        case 'BLOCKED':
            return CardPinStatus.BLOCKED;
        case 3:
        case 'PENDING':
            return CardPinStatus.PENDING;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardPinStatus.UNRECOGNIZED;
    }
}
exports.cardPinStatusFromJSON = cardPinStatusFromJSON;
function cardPinStatusToJSON(object) {
    switch (object) {
        case CardPinStatus.INVALID_CARD_PIN_STATUS:
            return 'INVALID_CARD_PIN_STATUS';
        case CardPinStatus.ACTIVE:
            return 'ACTIVE';
        case CardPinStatus.BLOCKED:
            return 'BLOCKED';
        case CardPinStatus.PENDING:
            return 'PENDING';
        case CardPinStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardPinStatusToJSON = cardPinStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=card-atm.js.map